module.exports = __webpack_public_path__ + "static/img/swiper17.f206b862.png";